import { useStaticQuery, graphql } from "gatsby";
import { LatestCovidCasesQuery } from "../../../graphql-types";

export const useLatestCovidCases = () => {
  const latestCovidCasesData = useStaticQuery<LatestCovidCasesQuery>(graphql`
    query LatestCovidCases {
      askAboutQuery {
        latestCovidCases {
          iso2
          alias
          displayName
          population
          totalCases
          totalCasesPerMillion
          totalDeaths
          totalDeathsPerMillion
          totalTests
          totalTestsPerThousand
          totalRecovered
          totalRecoveredPerMillion
          totalActive
          totalActivePerMillion
          averageNewCases
          averageNewCasesPerMillion
          averageNewDeath
          averageNewDeathPerMillion
          averageNewTests
          averageNewTestsPerThousand
          averageNewRecovered
          averageNewRecoveredPerMillion
          fatalityRate
        }
      }
    }
  `);

  return latestCovidCasesData.askAboutQuery.latestCovidCases;
};
